import {ChangeDetectionStrategy, Component} from '@angular/core';
import {IFilterAngularComp} from 'ag-grid-angular';
import {DatePipe} from '@angular/common';

@Component({ standalone: false,
    selector: 'irb-irb-ag-date-column-filter',
    templateUrl: './irb-ag-date-column-filter.component.html',
    styleUrls: ['./irb-ag-date-column-filter.component.scss'],
    providers: [DatePipe],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class IrbAgDateColumnFilterComponent implements IFilterAngularComp {

    fromDate: any;
    toDate: any;
    private params: any;
    private valueGetter: any;
    isDateValidationMsg: boolean;
    colHeaderMsg: any;
    selectedBtn: any;
    datePipe: DatePipe
    enableArchiveSearch = false;
    useArchivedData = false;
    defaultMaxCalendarDate = '9999-12-31';
    defaultMinCalendarDate = '';
    archivedDataAgeInDays = 31; // older than 30 days
    maxCalendarDate = this.defaultMaxCalendarDate;
    minCalendarDate = this.defaultMinCalendarDate;
    isVisible: boolean = false;
    private hidePopupFunc?: (params?: { hideReason?: string }) => void;

    constructor(datePipe: DatePipe) {
        this.datePipe = datePipe;
    }

    agInit(params: any): void {
        this.params = params;
        this.valueGetter = params.valueGetter;
        let date = new Date();
        this.fromDate = null;
        this.toDate = null;
        if (this.params && this.params.colDef && this.params.colDef.filterParams) {
            this.enableArchiveSearch = this.params.colDef.filterParams.enableArchiveSearch;
            if (this.enableArchiveSearch) {
                const currentDate = new Date();
                const formatDate = currentDate.setDate(currentDate.getDate() - this.archivedDataAgeInDays + 1);
                this.minCalendarDate = this.datePipe.transform(formatDate, 'yyyy-MM-dd', '-0500');
            }
        }
    }

    afterGuiAttached(params: any) {
        this.isVisible = true;
        if (params && params.hidePopup) {
            this.hidePopupFunc = params.hidePopup;
        }
    }

    afterGuiDetached() {
        this.isVisible = false;
    }

    isFilterActive(): boolean {
        return ((this.fromDate !== null && this.fromDate !== undefined && this.fromDate !== '') ||
            (this.toDate !== null && this.toDate !== undefined && this.toDate !== ''));
    }

    doesFilterPass(): boolean {
        return false;
    }

    getModelAsString(): any {
        return this.isFilterActive() ? (this.colHeaderMsg) : null;
    }

    getModel(): any {
        const fromDate = this.fromDate ? this.fromDate : '1970-01-01';
        const toDate = this.toDate ? this.toDate : '9999-12-31';
        return this.isFilterActive() ? {
            filterType:'IrbAgDateColumnFilter',
            filterFrom: fromDate,
            filterTo: toDate,
            type: 'inRange',
            isArchive: this.useArchivedData,
            colHeaderMsg: this.colHeaderMsg
        } : null;
    }

    setModel(model: any): void {
        if (typeof model === 'undefined')
            model = null;
        this.colHeaderMsg = model ? model.colHeaderMsg : '';
        this.fromDate = model ? model.filterFrom : '';
        this.toDate = model ? model.filterTo : '';
        if (model && model.isArchive !== null && model.isArchive !== undefined) {
            this.useArchivedData = model.isArchive;
        }
        if (model === null) {
            this.clearAllValues();
        }
    }

    onApplyAction(colHeaderMsg: any): void {

        if ((this.fromDate == null || this.fromDate == '') && (this.toDate == null || this.toDate == '')) {
            this.isDateValidationMsg = true;
        } else {
            this.colHeaderMsg = colHeaderMsg;
            if (this.colHeaderMsg == 'Range') {
                this.selectedBtn = '';
            }
            this.isDateValidationMsg = false;
            if (this.params != undefined) {
                this.params.filterChangedCallback();
                this.isVisible = false;
                if (this.hidePopupFunc) {
                    this.hidePopupFunc();
                }
            }
        }
    }

    onClearAction(): void {
        this.clearAllValues();
        if (this.params != undefined) {
            this.params.filterChangedCallback();
            this.isVisible = false;
            if (this.hidePopupFunc) {
                this.hidePopupFunc();
            }
        }
    }

    clearAllValues(): void {
        if (this.useArchivedData) {
            this.useArchivedData = false;
        }
        this.fromDate = null;
        this.toDate = null;
        this.isDateValidationMsg = false;
        this.selectedBtn = '';
    }

    setFilterDate(days: number = 0) {
        let startDate = new Date();
        let endDate = new Date();
        let toDays = 0;
        if (this.enableArchiveSearch) {
            if (this.useArchivedData) {
                toDays = this.archivedDataAgeInDays;
            } else {
                if (days > this.archivedDataAgeInDays - 1) {
                    days = this.archivedDataAgeInDays - 1;
                }
            }
        }
        let formatDate = startDate.setDate(startDate.getDate() - days);
        let formatToDate = endDate.setDate(endDate.getDate() - toDays);
        if (this.enableArchiveSearch && days === Math.round(((new Date()).getTime() - (new Date(0)).getTime()) / (1000 * 3600 * 24))) {
            this.fromDate = null;
        } else {
            this.fromDate = this.datePipe.transform(formatDate, 'yyyy-MM-dd', '-0500');
        }
        this.toDate = this.datePipe.transform(formatToDate, 'yyyy-MM-dd', '-0500');
    }

    getDate(days: number = 0, colHeaderMsg: any): void {
        if (this.enableArchiveSearch) {
            if (days > this.archivedDataAgeInDays) {
                this.useArchivedData = true;
            } else {
                this.useArchivedData = false;
            }
            this.archivedDataToggle(this.useArchivedData);
        } else {
            this.useArchivedData = false;
        }
        this.selectedBtn = colHeaderMsg;
        this.setFilterDate(days);
        this.onApplyAction(colHeaderMsg);
    }

    isArchivedDataOnChange(event: any) {
        this.archivedDataToggle(event.checked);
    }

    archivedDataToggle(checked: boolean) {
        const currentDate = new Date();
        let days = 0;
        if (checked && this.enableArchiveSearch) {
            const formatDate = currentDate.setDate(currentDate.getDate() - this.archivedDataAgeInDays);
            this.maxCalendarDate = this.datePipe.transform(formatDate, 'yyyy-MM-dd', '-0500');
            this.minCalendarDate = this.defaultMinCalendarDate;
            this.useArchivedData = true;
            if (this.selectedBtn && (this.selectedBtn.toLowerCase() === 'day' || this.selectedBtn.toLowerCase() === 'week'
                || this.selectedBtn.toLowerCase() === 'month')) {
                this.selectedBtn = '';
            }
            days = Math.round(((new Date()).getTime() - (new Date(0)).getTime()) / (1000 * 3600 * 24));
        } else {
            const formatDate = currentDate.setDate(currentDate.getDate() - this.archivedDataAgeInDays + 1);
            this.maxCalendarDate = this.defaultMaxCalendarDate;
            this.minCalendarDate = this.datePipe.transform(formatDate, 'yyyy-MM-dd', '-0500');
            this.useArchivedData = false;
        }
        this.selectedBtn = '';
        this.setFilterDate(days);
    }

}
